import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Home from '../pages/home_page/home'
import Login from '../pages/signIn_Page/signIn';
import Register from '../pages/signUp_page/signUp';
import UserHome from '../pages/user_home_page/user_home'
import HomeSelected from '../pages/home_selected/home_select'
import Timeline from '../pages/timeline/timeline'
import Browse from '../pages/browse/browse'
import Tournament from '../pages/tournament/tournament'
import Account from '../pages/account/account'
import ForgotPass from '../pages/forgot_password/forgotPassword'
import CreateGame from '../pages/create_game/createGame'

const Routes = () => (
  <Switch>
    <Route exact path="/" component={Home} />
    <Route exact path="/sign-up" component={Register} />
    <Route exact path="/sign-in" component={Login} />
    <Route exact path="/forgot-password" component={ForgotPass} />
    <Route exact path="/user-home" component={UserHome} />
    <Route exact path="/home-select" component={HomeSelected} />
    <Route exact path="/my-timeline" component={Timeline} />
    <Route exact path="/browse" component={Browse} />
    <Route exact path="/tournament" component={Tournament} />
    <Route exact path="/account" component={Account} />
    <Route exact path="/create-game" component={CreateGame} />
  </Switch>
);

export default Routes;